import Vue from 'vue';
import PromisePolyfill from 'promise-polyfill';
import ResizeObserverPolyfill from 'resize-observer-polyfill';

if (!window.Promise || !window.Promise.prototype.finally || !window.Promise.allSettled || !window.Promise.any) {
  window.Promise = PromisePolyfill;
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserverPolyfill;
}

if (typeof Vue.directive === 'function') {
  const fn = Vue.directive;

  Vue.directive = function (id, definition) {
    if (id && definition) {
      let __proto__ = this.options.directives;
      while (__proto__ && id in __proto__) {
        delete __proto__[id];
        __proto__ = Object.getPrototypeOf(__proto__);
      }
    }

    return fn.call(this, id, definition);
  };
}

/**
 * rt-qiankun polyfill
 * 注册 console.mute 方法
 */
if (window.console && !window.console.mute) {
  window.console.mute = window.console.log;
}

/**
 * rt-qiankun polyfill
 * 注册 window.optimizeCode 方法
 */
if (!window.optimizeCode) {
  window.optimizeCode = function optimizeCode (code) {
    return code;
  };
}

/**
 * rt-qiankun polyfill
 * 添加 window.__RT_QIANKUN_WINDOW__ 属性
 * 子应用独立运行时，返回当前window；qiankun模式下返回父应用的window
 */
window.__RT_QIANKUN_WINDOW__ = window.__RT_QIANKUN_WINDOW__ || window;

function overrideDate () {
  const OldDate = window.Date;
  // 重写arguments[0]
  window.Date = function () {
    if (
      arguments.length > 0 &&
      typeof arguments[0] === 'string' &&
      new OldDate(arguments[0]).toString() === 'Invalid Date' &&
      arguments[0].includes('-') &&
      !arguments[0].includes('T')
    ) {
      const p = arguments[0].replace(/-/g, '/');
      arguments[0] = p;
    }
    return new OldDate(...arguments);
  };

  // 继承原型函数
  window.Date.prototype = OldDate.prototype;

  // 继承静态函数，过滤已有的静态函数和参数，取数组差集
  const oldDateStaticParam = Object.getOwnPropertyNames(OldDate);
  const dateStaticParam = Object.getOwnPropertyNames(window.Date);
  const diffParam = [];
  for (let i = 0; i < oldDateStaticParam.length; i++) {
    let find = false;
    for (let j = 0; j < dateStaticParam.length; j++) {
      if (oldDateStaticParam[i] === dateStaticParam[j]) {
        find = true;
        break;
      }
    }
    if (!find) {
      diffParam.push(oldDateStaticParam[i]);
    }
  }
  for (let i = 0; i < diffParam.length; i++) {
    window.Date[diffParam[i]] = OldDate[diffParam[i]];
  }
}

if (
  navigator.userAgent.indexOf('Safari') > -1 &&
  navigator.userAgent.indexOf('Chrome') === -1
) {
  overrideDate();
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/polyfill.js